import PlanSaleBillingsService from "@/api/services/planSaleBillings";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
  currentPage: 1,
  totalPages: 0,
  totalCount: 0,
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    paymentStatusStyle: () => (paymentStatus) => {
      const normalized = String(paymentStatus || "")
        .trim()
        .toLowerCase();
      switch (normalized) {
        case "draft":
        case "waiting":
          return "bg-yellow-100 text-yellow-800";
        case "succeeded":
          return "bg-green-100 text-green-800";
        case "failed":
        case "disputed":
          return "bg-red-100 text-red-800";
        case "uncollectible":
          return "bg-gray-100 text-gray-800";
        default:
          return "";
      }
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.records;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, params = {}) {
      const response = await PlanSaleBillingsService.fetchIndex({ includes: ["plan_sale"], ...params });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },

    async fetchInvoice(_, { planSaleBillingId }) {
      const response = await PlanSaleBillingsService.fetchInvoice(planSaleBillingId);
      if (!response?.success) return response;

      return { ...response, data: toCamelCase(response.data) };
    },
  },
};
